var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	362: {
		fallback: () => (__webpack_require__.e(569).then(() => (() => (__webpack_require__(950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	573: {
		fallback: () => (__webpack_require__.e(3).then(() => (() => (__webpack_require__(3))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	580: {
		fallback: () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(43))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	820: {
		fallback: () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(556))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"175": [
		580
	],
	"384": [
		580
	],
	"942": [
		362,
		573,
		580,
		820
	],
	"950": [
		580
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}